<template>
  <div>
   
    <v-card-title>
      <h2>Personal Leave Status [Casual Leave Only]</h2>
      <v-spacer></v-spacer>

      <!-- <v-btn class="mx-0" color="info" title="Download" @click="downloadFIle">
        <v-icon color="white">cloud_download</v-icon>
      </v-btn>   -->

      <v-btn color="error" @click="previous" title="Back">
          <v-icon>arrow_back_ios</v-icon>Back
        </v-btn>

    </v-card-title>

     <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Approved Casual Leave(s) for the Year </th>
        </tr>
        <tr>
          <th>Project Name</th>
          <td colspan="3" style="font-weight:bold; padding-left:8px;">{{projectName}}</td>
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th style="width:10%">Sl</th> 
          <th style="width:25%">Leave</th> 
          <th style="width:25%">Duration</th> 
          <th style="width:40%">Purpose of the Leave</th> 
        </tr>

        <tr v-for="(item,index) in leaveEntryList" :key="index" class="textCenter">       
          <td>{{++index}}</td>   
          <td>{{ item.leave_type_name }}</td>
          <td>{{'From '+formateDate(item.from_date)+' to '+formateDate(item.to_date)}} {{'( '+item.total_days+' days)'}}</td>
          <td>{{item.leave_purpose}}</td>
        </tr>
      </tbody>
    </table>
    <br><br>

 </div>
</template>
<script>
const commonService = require('../../../services/common.service');
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {

  data: () => ({
    valid: true,    
    leaveEntryList:[],
    projectName:''
    
  }),

  created() {
    let query_Data2 = this.queryData2;
        
        let leaveInfoId = sessionStorage.getItem("leaveInfoId")
         

        commonService.getAllDataById(leaveInfoId, "leave-management")
        .then(res => {
          this.leaveEntryList = res.data
          this.projectName = this.leaveEntryList[0].project_name
          
        })   
  },

  
  methods: {
    formateDate(value){

        return new Date(value).toDateString().split(' ').slice(1).join(' ')
    },
    downloadFIle(){

      let query_Data2 = this.queryData2;
        
        (query_Data2.trainInfoId = sessionStorage.getItem("trainInfoId"))
        

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/training-details-pdf?'+parameters;
      window.open(route, '_blank');
    },

    previous(){
      this.$router.push('/administration/leave-entry') 
    }
  }
};
</script>

<style scoped>
.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>


// WEBPACK FOOTER //
// src/components/administration/leave_entry/detailsLeave.vue